import { isNativeIOS, openTextFileOnNative } from '@/utils/nativeAndroidFiles';

function isIOS() {
  const ua = window.navigator.userAgent || '';
  const iOSDevice = /iPad|iPhone|iPod/.test(ua);
  const iPadOS = window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1;
  return iOSDevice || iPadOS;
}

function isSafariBrowser() {
  const ua = window.navigator.userAgent || '';
  return /^((?!chrome|android).)*safari/i.test(ua);
}

function isAndroid() {
  const ua = window.navigator.userAgent || '';
  return /Android/i.test(ua);
}

export async function downloadICSFile(content, filename) {
  const mimeType = 'text/calendar';
  const blob = new Blob([content], { type: mimeType });

  try {
    if (await openTextFileOnNative(content, filename, mimeType)) {
      return;
    }
  } catch (error) {
    console.error('Falha no export nativo de ICS, usando fallback web:', error);
  }

  const isMobile = isIOS() || isAndroid();
  const shouldUseMobileFallback = isMobile || isSafariBrowser();

  if (shouldUseMobileFallback) {
    try {
      const file = new File([blob], filename, { type: mimeType });
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({
          files: [file],
          title: filename,
          text: isNativeIOS() ? 'Escolha Calendario para adicionar na agenda do iPhone.' : undefined,
        });
        return;
      }
    } catch (_) {
      // fallback below
    }

    const url = window.URL.createObjectURL(blob);

    // No iPhone/iPad, abrir o .ics no mesmo contexto do app ajuda o sistema
    // a exibir a opcao de adicionar no Calendario.
    if (isNativeIOS() || isIOS()) {
      window.location.href = url;
    } else if (isMobile) {
      const a = document.createElement('a');
      a.href = url;
      a.target = '_self';
      a.rel = 'noopener noreferrer';
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
    } else {
      const a = document.createElement('a');
      a.href = url;
      a.target = '_blank';
      a.rel = 'noopener noreferrer';
      document.body.appendChild(a);
      a.click();
      a.remove();
    }

    setTimeout(() => window.URL.revokeObjectURL(url), 5000);
    return;
  }

  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}
